"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_get_1 = __importDefault(require("lodash.get"));
var enums_1 = require("../../Common/utils/enums");
var useExperiment_1 = __importDefault(require("../../Common/utils/useExperiment"));
var VGS_SUBMIT_URL = '/in/consumerweb/graphql';
var VGS_SCRIPT_URL = 'https://js.verygoodvault.com/vgs-collect/2.7.0/vgs-collect.js';
var VGS_VAULT_ENV;
(function (VGS_VAULT_ENV) {
    VGS_VAULT_ENV["PRODUCTION"] = "live";
    VGS_VAULT_ENV["SANDBOX"] = "sandbox";
})(VGS_VAULT_ENV || (VGS_VAULT_ENV = {}));
var VGS_VAULT_ID;
(function (VGS_VAULT_ID) {
    VGS_VAULT_ID["PRODUCTION"] = "tnt6lmmk3ml";
    VGS_VAULT_ID["SANDBOX"] = "tntcmtf4wpl";
})(VGS_VAULT_ID || (VGS_VAULT_ID = {}));
var VGS_VAULT_CNAME;
(function (VGS_VAULT_CNAME) {
    VGS_VAULT_CNAME["PRODUCTION"] = "vgs.doordash.com";
    VGS_VAULT_CNAME["SANDBOX"] = "vgs.doorcrawl.com";
})(VGS_VAULT_CNAME || (VGS_VAULT_CNAME = {}));
var getVgsConfig = function (vaultId) {
    var vaultConfig = {
        VAULT_ENV: '',
        VAULT_CNAME: ''
    };
    switch (vaultId) {
        case VGS_VAULT_ID.PRODUCTION: {
            vaultConfig = {
                VAULT_ENV: VGS_VAULT_ENV.PRODUCTION,
                VAULT_CNAME: VGS_VAULT_CNAME.PRODUCTION
            };
            break;
        }
        case VGS_VAULT_ID.SANDBOX: {
            vaultConfig = {
                VAULT_ENV: VGS_VAULT_ENV.PRODUCTION,
                VAULT_CNAME: VGS_VAULT_CNAME.SANDBOX
            };
            break;
        }
    }
    return __assign({ VAULT_ID: vaultId, SCRIPT_URL: VGS_SCRIPT_URL, SUBMIT_URL: VGS_SUBMIT_URL }, vaultConfig);
};
var useVgsPaymentConfig = function (paymentConfig) {
    var isFraudVgsEnabled = useExperiment_1["default"]('isFraudVgsEnabled');
    if (!isFraudVgsEnabled) {
        return {
            isFraudVgsProviderEnabled: false,
            vgsConfig: {}
        };
    }
    var vaultId = lodash_get_1["default"](paymentConfig, 'cardConfig.key') || '';
    var isFraudVgsProviderEnabled = lodash_get_1["default"](paymentConfig, 'cardConfig.provider') === enums_1.TokenizationProvider.VGS;
    return {
        isFraudVgsProviderEnabled: isFraudVgsProviderEnabled,
        vgsConfig: isFraudVgsProviderEnabled
            ? getVgsConfig(vaultId)
            : {}
    };
};
exports["default"] = useVgsPaymentConfig;
